<template>
  <main class="grid-container">
    <div class="section-header section-header--xl section-header--dividing mt-3">
      <h1 qaid="contact-us-form-header" class="heading">
        {{ getBaseProperty('title') }}
      </h1>
    </div>

    <div class="max-w-sm">
      <form
        id="contactUsForm"
        ref="contactUsForm"
        modelAttribute="contactUsForm"
        action="contact-us-confirmation"
        method="post"
        qaid="contact-us-form-form"
        @submit.prevent="validateAndSubmit"
      >
        <input
          id="dealerId"
          v-model="dealerId"
          path="dealerId"
          type="hidden"
          name="dealerId"
          value
          maxlength="100"
          qaid="contact-us-form-dealerId"
        />
        <input
          id="userName"
          v-model="username"
          path="userName"
          type="hidden"
          name="userName"
          maxlength="100"
          qaid="contact-us-form-userName"
        />
        <input
          id="sessionLanguage"
          v-model="sessionLanguage"
          path="sessionLanguage"
          type="hidden"
          name="sessionLanguage"
          maxlength="100"
          qaid="contact-us-form-sessionLanguage"
        />

        <input
          id="dealerBranch"
          v-model="dealerBranch"
          path="dealerBranch"
          type="hidden"
          name="dealerBranch"
          maxlength="100"
          qaid="contact-us-form-dealerBranch"
        />

        <form-group
          id="contactName"
          v-model="contactNameField"
          v-validate="'required'"
          :data-vv-as="getBaseProperty('contactName')"
          :label="getBaseProperty('contactName')"
          :error="bp('contactNameError')"
          :maxlength="100"
          type="text"
          name="contactName"
          qaid="contact-us-form-contactName"
          :show-error-messages="fieldHasError('contactName')"
          @input="fieldHasError('contactName')"
        />

        <div class="form-group">
          <label class="form-label" qaid="contact-us-form-topic">
            {{ getBaseProperty('topic') }}
          </label>
          <div class="select">
            <select
              id="topic"
              v-model="selectedTopic"
              class="form-control"
              name="topic"
              qaid="contact-us-form-selectedTopic"
              required
            >
              <option v-for="(option, index) in topics" :key="index" :value="option.id">
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>

        <form-group
          id="email"
          v-model="emailField"
          v-validate="'required|email'"
          :data-vv-as="getBaseProperty('email')"
          :label="getBaseProperty('email')"
          :error="bp('emailError')"
          :maxlength="100"
          type="email"
          name="email"
          qaid="contact-us-form-email"
          :show-error-messages="fieldHasError('email')"
          @input="fieldHasError('email')"
        />

        <input type="hidden" name="ignore_redirectmode" value="Auto" />
        <form-group
          id="messageText"
          v-model="commentsField"
          v-validate="'required'"
          :data-vv-as="getBaseProperty('questions')"
          :label="getBaseProperty('questions')"
          :error="bp('questionsError')"
          :maxlength="2000"
          type="textarea"
          name="messageText"
          qaid="contact-us-form-questions"
          :show-error-messages="fieldHasError('messageText')"
          @input="fieldHasError('messageText')"
        />

        <div class="buttons pb-5">
          <trek-button primary type="submit" qaid="contact-us-form-submit">
            <span v-html="getBaseProperty('submit')" />
          </trek-button>
        </div>
      </form>
    </div>
  </main>
</template>

<script>
import TrekButton from '@/components/TrekButton';
import FormGroup from '@/components/FormGroup';

export default {
  components: {
    FormGroup,
    TrekButton,
  },
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    dealerId: {
      type: String,
      default: '',
    },
    sessionLanguage: {
      type: String,
      default: '',
    },
    dealerBranch: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
    contactUsName: {
      type: String,
      default: '',
    },
    contactUsEmail: {
      type: String,
      default: '',
    },
    topics: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      serialNumberField: '',
      userNameField: '',
      dealerIdField: '',
      sessionLanguageField: '',
      dealerBranchField: '',
      contactNameField: this.contactUsName,
      selectedTopic: 'customerCareRep',
      emailField: this.contactUsEmail,
      commentsField: '',
    };
  },

  methods: {
    validateAndSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) this.$refs.contactUsForm.submit();
      });
    },
    fieldHasError(nameOfField) {
      return !!this.$validator.errors.items.find((o) => o.field == nameOfField);
    },
  },
};
</script>
